import {
  Form,
  Heading,
  PasswordInput,
  Stack,
  Checkbox,
} from "@carbon/react";
// import BanvoxLogo from "~/assets/banvox.png";
// import BanvoxLogo from "~/assets/it4.png";
import BanvoxLogo from "~/assets/prosperita.png";
import BgLogin from "~/assets/pattern_color_main-prosperita.png";
import styled from "styled-components";
import Margin from "~/components/Margin";

import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { getTokenAPI } from "~/services/api/auth";
import { useCallback, useState } from "react";
import AppStorage from "~/services/storage";
import MaskedTextInput from "~/components/InputMask";
import { onlyNumbers } from "~/services/utils";
import useLoading from "~/hooks/useLoading";
import { useCookies } from "react-cookie";
import { Button, Notification } from "prosperita-dumbo-react";
import ArrowIcon from "~/assets/arrow-right-_1_.png";
import { useNotification } from "~/hooks/useNotification";
import { getErrorMessage } from "~/services/api/error";

const LoginContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: #fff;
  .right-image {
    flex: 1;
    height: 100vh;
    background-image: url(${BgLogin});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #fff;
    @media (max-width: 768px) {
      display: none;
    }
  }

  .form-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
    width: 100%;
    max-width: 480px;
    background-color: #fff;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
    padding-top: 72px;
  }

  .form-btn {
    width: 100%;
    max-width: 100%;
    background-color: #fff;
  }

  .header {
    z-index: 1;
  }
`;

const HeadingContainer = styled.div`
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
  background-color: #fff;
`;

const RememberMeContainer = styled.div`
  margin-top: 1rem;
`;

// const BottomLinkContainer = styled.div`
//   margin: 1rem 0;
//   padding-bottom: 2rem;
//   border-bottom: 1px solid #e0e0e0;
// `;

type Values = {
  username: string;
  password: string;
};

const initialValues: Values = {
  username: "",
  password: "",
};

const FormSchema = Yup.object().shape({
  username: Yup.string().required("Campo obrigatório"),
  password: Yup.string().required("Campo obrigatório"),
});

const Login = () => {
  const navigate = useNavigate();

  // removed inline error box; using toast instead
  const { setLoading } = useLoading();
  const [rememberMe, setRememberMe] = useState<boolean | undefined>(false);
  console.log("teste");
  const [, setCookie] = useCookies();
  const { notification, showNotification } = useNotification();
 
  const handleSend = async (values: Values) => {
    setLoading(true);
    if (rememberMe) {
      AppStorage.set("@app:username", values.username);
    } else {
      AppStorage.remove("@app:username");
    }

    try {
      const payload = {
        username: onlyNumbers(values.username),
        password: values.password,
      };

      const {
        data: {
          payload: { access, refresh },
        },
      } = await getTokenAPI(payload);

      if (access && refresh) {
        setCookie(
          "token_cred_engine",
          { access, refresh },
          {
            path: "/",
            expires: new Date(Date.now() + 24 * 60 * 60 * 1000),
            secure: window.location.hostname !== "localhost",
            sameSite:
              window.location.hostname === "localhost" ? "lax" : "strict",
            domain:
              window.location.hostname === "localhost"
                ? undefined
                : ".prosperita.io",
          }
        );

        AppStorage.setToken(access);
        AppStorage.setRefresh(refresh);

        setLoading(false);

        navigate("/app/credit/simulations");
      }
    } catch (error) {
      console.error("Error while trying to login:", error);
      const message = getErrorMessage(
        error,
        "Nenhuma conta encontrada com as credenciais fornecidas."
      );
      showNotification({ status: "error", title: "Erro!", message });
      setLoading(false);
    }
  };

  const { values, errors, handleChange, handleSubmit } = useFormik({
    initialValues,
    validationSchema: FormSchema,
    onSubmit: handleSend,
  });
  const handleChangeRememberMe = useCallback(() => {
    const newRememberMe = !rememberMe;
    setRememberMe(newRememberMe);
    AppStorage.set("@app:rememberMe", String(newRememberMe));
  }, [rememberMe]);

  return (
    <LoginContainer>
      <div className="form-container">
        <div style={{ marginLeft: "35px", width: "85%" }}>
          <Form onSubmit={handleSubmit}>
          <Margin mb={60} />
            <img
              style={{
                height: "90px",
                position: "relative",
                marginBottom: "8px",
              }}
              src={BanvoxLogo}
              alt=""
            />
            <Margin mb={-6} />
            <Heading
              style={{
                fontSize: "24px",
                textAlign: "start",
                marginLeft: "60px",
             
              }}
            >
              Portal de Crédito
            </Heading>
              <Margin mb={80} />
            <HeadingContainer>
              <Heading>Efetuar login</Heading>
            </HeadingContainer>

            <Stack gap={5}>

              <p
                style={{ fontSize: "12px", color: "black", fontWeight: "300" }}
              >
                Digite seu CPF
              </p>
              <MaskedTextInput
                id="username"
                mask="999.999.999-99"
                onChange={handleChange("username")}
                placeholder="000.000.000-00"
                value={values.username}
              />

              <PasswordInput
                id="password"
                labelText="Senha"
                placeholder="Digite sua senha"
                type="password"
                onChange={handleChange("password")}
                value={values.password}
                helperText={errors.password}
                required
              />

              <div style={{ marginTop: "5px" }}>
                <Button
                  kind="primary"
                  label="Continuar"
                  size="medium"
                  icon={ArrowIcon}
                  onClick={() => handleSend(values)}
                />
              </div>
              <RememberMeContainer>
                <Checkbox
                  id="remember-me"
                  labelText="Lembrar de mim"
                  checked={rememberMe}
                  onChange={() => handleChangeRememberMe()}
                />
              </RememberMeContainer>
            </Stack>
          </Form>
        </div>
      </div>
      <div className="right-image"></div>
      <Notification
        actived={notification.actived}
        zindex={notification.zindex}
        status={notification.status}
        message={notification.message}
        title={notification.title}
      />
    </LoginContainer>
  );
};

export default Login;
